<template>
  <div
    class="ioc-alarm__list"
    :class="{ closeList: isShowList }"
    :style="leftTop"
  >
    <div class="blur-bg map-blur-panel"></div>
    <div v-if="title" class="ioc-alarm__list__title">
      <span :title="title">{{ title }}</span>
    </div>
    <el-scrollbar ref="alarmList" class="ioc-alarm__scrollbar">
      <div class="noData" v-if="data.length === 0 && !isShowList">
        <div>
          <img src="@/common/assets/images/empty.svg" class="no-data_img" />
        </div>
        <div>暂无数据</div>
      </div>
      <ul class="ioc-alarm__list__item">
        <li
          v-for="(item, index) in data"
          :key="index"
          class="map-blur-panel__list-item"
          :class="[
            alarmColor(item.level),
            activeInfo && item[flag] == activeInfo[flag] ? 'active' : '',
          ]"
          @click="itemClick(item)"
        >
          <div class="alarm_name" :title="item.emergencyPlanName">
            {{ item.emergencyPlanName }}
          </div>
          <div
            v-if="item[prop.groupName]"
            class="alarm_area"
            :title="item[prop.groupName]"
          >
            {{ item[prop.groupName] }}
          </div>
          <div class="alarm_time">{{ item[prop.time] | moment }}</div>
          <span style="bottom: 33px; position: absolute; right: 23px">{{
            item[prop.status] | showStatus(item)
          }}</span>
        </li>
      </ul>
    </el-scrollbar>
    <div
      :class="[
        'ioc-alarm__list__actionBtn case expand-left iconfont-lunan',
        isShowList
          ? 'icon-lunan-shousuocaidan-copy'
          : 'icon-lunan-shousuocaidan',
      ]"
      @click="showAlarmList"
    ></div>
    <div class="handle-alarm-button" v-if="addBtn.show">
      <el-button type="primary" @click="handleAddBtn">{{
        addBtn.text
      }}</el-button>
    </div>
    <div v-show="isShowTypeCard" class="ioc-alarm__list__type">
      <alarmTypeCard
        :data="systemAttrs.checkedSubSystem"
        @cardClose="typeCardClose"
        @cardCloseCon="cardCloseCon"
        @searchType="handleSearchType"
      ></alarmTypeCard>
    </div>
  </div>
</template>
<script>
import alarmTypeCard from "./alarmTypeCard";
import { Dic } from "$utils";
export default {
  components: { alarmTypeCard },
  filters: {
    alarmName(alarmType, item) {
      const value = Dic.findByValue("SENU073001", alarmType);
      const level = Dic.findByValue("SENU073002", item.level);
      const planName = item.emergencyPlanName || "";
      return value ? `【${value} - ${level}】${planName}` : planName;
    },
    showStatus(status, item) {
      let label = "";
      switch (parseInt(status)) {
        case 1:
          label = "未启动";
          break;
        case 2:
          label = "执行中";
          break;
        case 3:
          label = "已完成";
          break;
        default:
          break;
      }
      return label;
    },
  },
  computed: {
    leftTop() {
      let styles = "";
      if (this.styles.left) {
        styles += `left:${this.styles.left};`;
      }
      if (this.styles.top) {
        styles += `top:${this.styles.top};`;
      }
      return styles;
    },
  },
  props: {
    addBtn: {
      type: Object,
      default: () => {
        return {
          show: false,
        };
      },
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isShowSearch: {
      type: Boolean,
      default: false,
    },
    prop: {
      type: Object,
      default: () => {
        return {};
      },
    },
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    flag: {
      type: String,
      default: () => {
        return "";
      },
    },
    data: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      activeInfo: null,
      isAllSubSystem: false,
      isShowTypeCard: false,
      isShowList: true,
      alarmList: "",
      boxScrollContainer: "",
      scrollView: "",
      subSystem: "",
      eventType: "",
      alarmTypes: [],
      systemAttrs: {
        alarmTime: "",
        deviceName: "",
        alarmStartTime: "",
        alarmEndTime: "",
        isIndeterminate: false,
        checkAll: false,
        checkedSubSystem: [],
        subSystems: Dic.find("SENU004"),
      },
      //所有告警类型字典
      alarmTypesDic: [],
    };
  },
  mounted() {
    this.scrollbar();
    this.isShowList = false;
    // this.getAlarmTypes()
  },
  methods: {
    handleAddBtn() {
      this.$emit("handleAddBtn");
    },
    // 获取所有告警类型
    getAlarmTypes() {
      _.map(_.map(Dic.find("SENU004"), "value"), (o) => {
        let alarmTypesDic = Dic.find("SENU004", {
          relation: o,
        });
        this.alarmTypesDic = this.alarmTypesDic.concat(alarmTypesDic);
      });
      this.alarmTypesDic = [
        { value: "", label: this.$t("realTimeAlarm.label.allTypes") },
      ].concat(this.alarmTypesDic);
    },
    alarmColor(level) {
      let className = "common";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    itemClick(item) {
      // console.log(item);
      this.activeInfo = { ...item };
      this.$emit("clickAlarm", item);
    },
    clickArrow() {
      this.isAllSubSystem = !this.isAllSubSystem;
    },
    handleCheckAllChange(val) {
      this.systemAttrs.checkedSubSystem = val
        ? _.map(this.systemAttrs.subSystems, "value")
        : [];
      this.isIndeterminate = false;
      this.isShowTypeCard = val ? true : false;
    },
    handleFocus() {
      //      if (!this.isShowTypeCard) {
      //        this.isShowTypeCard = true
      //      }
    },
    handleCheckedSystemsChange(value) {
      let checkedCount = value.length;
      this.systemAttrs.checkAll =
        checkedCount === this.systemAttrs.subSystems.length;
      this.systemAttrs.isIndeterminate =
        checkedCount > 0 && checkedCount < this.systemAttrs.subSystems.length;
      if (!this.isShowTypeCard) {
        this.isShowTypeCard = true;
      }
      if (checkedCount === 0) {
        this.isShowTypeCard = false;
      }
    },
    typeCardClose() {
      this.systemAttrs.checkedSubSystem = [];
      this.systemAttrs.isIndeterminate = false;
      this.systemAttrs.checkAll = false;
      this.isShowTypeCard = false;
    },
    cardCloseCon() {
      this.isShowTypeCard = false;
    },
    handleSearchType(val, label) {
      this.systemAttrs.checkedSubSystem = label;
      this.isSelectedDevice = true;
      this.$emit("searchAlarmTypes", val);
    },
    showAlarmList() {
      this.isShowList = !this.isShowList;
      // setTimeout(() => {
      //   this.isShowSearch = !this.isShowSearch
      // }, 300)
    },
    handleChangeSystem(val) {
      this.systemAttrs.checkedSubSystem = val;
      this.isShowTypeCard = val && val.length ? true : false;
    },
    // 告警类型变更时
    handleChange(val) {
      let params = val ? [String(val)] : "";
      this.$emit("searchAlarmTypes", params);
    },
    scrollbar() {
      this.alarmList = this.$refs.alarmList;
      this.boxScrollContainer = this.alarmList.$el.querySelector(
        ".el-scrollbar__wrap"
      );
      this.scrollView = this.boxScrollContainer.querySelector(
        ".el-scrollbar__view"
      );
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
            this.scrollView.clientHeight &&
          !this.isLoading
        ) {
          this.$emit("nextPage");
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    handleChangeDeviceName(val) {
      this.$emit("searchDeviceName", val);
    },
    handleRestBtn() {
      this.systemAttrs.deviceName = "";
      this.systemAttrs.checkedSubSystem = [];
      // this.systemAttrs.subSystems = []
      this.systemAttrs.alarmTime = "";

      this.$emit("restBtn");
    },
    handleSearchBtn() {
      this.$emit("searchBtn");
    },
    handleChangeTime(val) {
      this.$emit("searchAlarmTime", val);
    },
  },
};
</script>
